const normalize = (value) => (value || '').toString().toLowerCase()

const inventoryMovementProcessMap = (processId, processType, action, movement = {}) => {
  const normalizedType = normalize(processType)

  if (movement.process_detail_path || movement.detail_path) return movement.process_detail_path || movement.detail_path

  if (!processId) return null

  if (normalizedType.includes('internalrequest') || normalizedType.includes('internal_request')) {
    return `/app/outbounds/internal-requests/${processId}/detail-page`
  }

  if (normalizedType.includes('seller::outbound::return') || normalizedType.includes('sellerreturn') || normalizedType.includes('seller_return')) {
    return `/app/seller-outbound-returns/${processId}`
  }

  // Deal / Outbound / Payment / Shipment movement rows are intentionally read-only
  // until the exact detail route is confirmed in the dashboard repo.

  if (normalizedType.includes('shipment')) {
    return `/app/customer-shipments/${processId}`
  }

  if (movement.deal_id || movement.dealId || movement.reference_id || movement.referenceId) {
    const dealId = movement.deal_id || movement.dealId || movement.reference_id || movement.referenceId

    if (normalize(action).includes('shipment') || normalizedType.includes('outbound') || normalizedType.includes('deal')) {
      return `/app/outbound/deals/${dealId}`
    }
  }

  return null
}

export default inventoryMovementProcessMap
